import { Box, BoxProps, CheckBox, Text, TextNewProps, TextProps } from '@jfs/ui-new'
import { useState } from 'react'
import { ActionButton } from './ActionButton'
import { Anchor } from './Anchor'
import { EnableVpa } from './EnableVpa'
import { Entity } from './Entity'
import { GenerateFile } from './GenerateFile'
import { VpaStatus } from './VpaStatus'

interface ListColumnProps {
  type?: string
  label: string
  size: number
  onAction?: () => void
  onEdit?: () => void
  onDelete?: () => void
  onPress?: () => void
  hrefPath?: string
  isActionLoading?: boolean
  loadingIndex?: number
  index: number
  columnIndex?: any
  onChecked?: (isChecked, index) => void
  columnWidth?: any
  cellTextStyle?: TextProps
}

// const returnLabel = (type: string) => {
//   if (type === 'active') return 'active'
//   else if (type === 'scheduled') return 'scheduled'
//   else return 'completed'
// }

const ListColumn = ({
  type = 'default',
  label = '',
  size,
  onAction,
  onPress,
  onEdit,
  onDelete,
  hrefPath,
  isActionLoading,
  loadingIndex,
  index,
  columnIndex,
  onChecked,
  columnWidth,
  cellTextStyle,
}: ListColumnProps) => {
  const [hover, setHover] = useState(false)
  const handlePress = () => {
    onPress && onPress()
  }

  const handleOnCheck = (val) => {
    onChecked && onChecked(val, index)
  }

  const getView: any = {
    edit: <ActionButton type={type} label={'Edit'} onAction={onEdit} />,
    delete: <ActionButton type={type} label={'Delete'} onAction={onDelete} />,
    generateFile: <GenerateFile label={label} onAction={onAction} />,
    entityId: <Entity label={label} type={type} setHover={setHover} handlePress={handlePress} hover={hover} />,
    ID: (
      <Anchor
        type={type}
        label={label}
        hrefPath={hrefPath}
        hover={hover}
        setHover={setHover}
        handlePress={handlePress}
      />
    ),
    link: <Entity type={type} label={'Download'} setHover={setHover} handlePress={handlePress} hover={hover} />,
    downloadEntityConfig: (
      <Entity type={type} label={'Download'} setHover={setHover} handlePress={onAction} hover={hover} />
    ),
    mapping: (
      <ActionButton
        type={type}
        label={label}
        onAction={handlePress}
        isLoading={isActionLoading && loadingIndex === index}
      />
    ),
    vpaStatus: <VpaStatus title={label} color={'RED'} />,
    enableVpa: <EnableVpa title={label} onPress={onPress} />,
    check: <CheckBox value={label} onChange={handleOnCheck} />,
  }
  return (
    <Box
      f={size}
      testID={'table-cell-' + index + '-' + columnIndex}
      marginRight={columnWidth ? 0 : 18}
      paddingRight={columnWidth ? 4 : 0}
      w={columnWidth}>
      {getView[type] ?? (
        <Text fontFamily="jiotype-medium" fontSize={12} color={'BLACK_21'} numberOfLines={1} {...cellTextStyle}>
          {label?.toString()}
        </Text>
      )}
    </Box>
  )
}

export const styles = {
  labelStyle: {
    fontWeight: 'MEDIUM',
    fontSize: 12,
    fontFamily: 'jiotype-medium',
  } as TextProps,
  buttonStyle: {
    type: 'body12',
    fontWeight: 'MEDIUM',
    color: 'WHITE',
  } as TextNewProps,
  buttonContainer: {
    backgroundColor: 'PRIMARY',
    padding: 8,
    borderRadius: 4,
    underlayColor: 'PRIMARY_STORNG',
  } as BoxProps,
}

export { ListColumn }
